export const MESSAGE = 'MESSAGE';
export const RATING = 'SLIDING';
export const YES_NO = 'YES_NO';
export const ENPS = 'NPS';
export const ICONS = 'FIXED';
export const DROPDOWN = 'DROPDOWN';
export const MULTIPLE_CHOICE = 'MULTIPLE';
export const TEXT = 'OPEN';

export const LIST = [MESSAGE, RATING, YES_NO, ENPS, ICONS, DROPDOWN, MULTIPLE_CHOICE, TEXT];

export default MESSAGE;
